var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row d-flex" }, [
    _c("div", { staticClass: "col-auto my-auto" }, [
      _vm._v("\n        Filter:\n    ")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-auto" },
      [
        _c(
          "input-group",
          {
            attrs: { icon: "fas fa-filter", append: _vm.canClear },
            scopedSlots: _vm._u([
              {
                key: "append",
                fn: function() {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-danger",
                        attrs: {
                          title: "Clear filters",
                          "data-toggle": "tooltip"
                        },
                        on: { click: _vm.clear }
                      },
                      [_c("i", { staticClass: "fas fa-times" })]
                    )
                  ]
                },
                proxy: true
              }
            ])
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.value,
                  expression: "value"
                }
              ],
              ref: "input",
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.value },
              on: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape"
                    ])
                  ) {
                    return null
                  }
                  return _vm.clear($event)
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.value = $event.target.value
                }
              }
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }